import { cn } from "twyne-new.ui"

function ReportBody({ children, className = '', contentClassName = '', hasSummaryCards = false }) {
  const wrapperClassName = cn(
    'p-2 twy-bg-base h-[calc(100vh-7.5rem)]',
    hasSummaryCards ? 'h-[calc(100vh-13.75rem)]! py-0!' : '',
    className,
  )

  const contentWrapperClassName = cn(
    'twy-bg-base-accent shadow rounded h-full max-h-[calc(100vh-7.5rem)] overflow-y-auto',
    contentClassName,
  )

  return <div className='w-full h-full twy-bg-base'>
    <div className={wrapperClassName}>
      <div className={contentWrapperClassName}>
        {children}
      </div>
    </div>
  </div>
}

export { ReportBody }
